import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { User } from 'src/app/models/user.model';

@Component({
  selector: 'app-confirm-deactivate-user-dialog',
  template: `
    <div class="flex flex-col items-center gap-2 px-6 pb-2 pt-6">
      <div
        class="flex h-12 w-12 items-center justify-center rounded-full bg-red-100"
        aria-hidden="true"
      >
        <mat-icon class="text-red-600" aria-hidden="true">delete</mat-icon>
      </div>
      <h2 mat-dialog-title>Remove user?</h2>
    </div>
    <mat-dialog-content class="!pt-2">
      <p class="text-center font-lato text-gray-700">
        <span class="font-bold">{{ data.Name }}</span>
        will immediately lose access to the portal. You can reactivate them
        later.
      </p>
    </mat-dialog-content>
    <mat-dialog-actions>
      <div class="flex w-full justify-center gap-2 px-8 pb-4">
        <button type="button" class="btn-secondary" [mat-dialog-close]="false">Cancel</button>
        <button type="button" class="btn-danger" (click)="onConfirm()">Remove</button>
      </div>
    </mat-dialog-actions>
  `,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
})
export class ConfirmDeactivateUserDialogComponent {
  dialogRef = inject(MatDialogRef<ConfirmDeactivateUserDialogComponent>);

  data = inject<Partial<User>>(MAT_DIALOG_DATA);

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
